import React, { useState, useEffect, useRef, useMemo } from 'react';
import { translatedMessage } from '../../service/LanguageService';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressSpinner } from 'primereact/progressspinner';
import DataTableUtils from '../../utilities/DataTableUtils';
import { CompetitionService } from '../../service/CompetitionService';

const CompetitionBibliographyListViewComponent = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [bibliographyList, setBibliographyList] = useState(null);

    const toast = useRef(null);
    const dt = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        setIsLoading(true)
        
        const getBibliography = async () => {
            await competitionService.getCompetitionBibliographyList(props?.competition?.id)
                .then((_itList) => {
                    // console.log("itList: ", _itList);
                    setBibliographyList(_itList);
                    setIsLoading(false);
                })
                .catch((error) => error && toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        };

        getBibliography()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props, competitionService]);



    if (isLoading) {
        return (
            <div className='w-full flex align-items-center'>
                <Toast ref={toast}></Toast>
                <ProgressSpinner />
            </div>
        );
    } else {
        return (
            <>
                <Toast ref={toast} />
                <div className='col-12 mt-5'>
                    <h5 className='mb-1'>{translatedMessage('competition.requirements.bibliography.title')}</h5>
                    <DataTable
                        ref={dt}
                        value={bibliographyList}
                        dataKey="id"
                        // paginator
                        rows={DataTableUtils.defalRowsPerPage()}
                        rowsPerPageOptions={DataTableUtils.rowsPerPageOptions()}
                        className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate={"{first} - {last} " + translatedMessage('generic.of') + " {totalRecords}"}
                        emptyMessage={translatedMessage("generic.tableEmptyMessage")}
                        responsiveLayout="scroll"
                    >
                        <Column
                            field="bibliography"
                            header={translatedMessage("competition.requirements.bibliography")}
                            headerStyle={{ width: '25%', minWidth: '8rem' }}
                        />
                        <Column
                            field="topic"
                            header={translatedMessage("competition.requirements.topic")}
                            headerStyle={{ width: '65%', minWidth: '8rem' }}
                        />
                    </DataTable>
                </div>
            </>
        );
    }
};

export default CompetitionBibliographyListViewComponent;
